// Firebase configuration
import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyCdCEMBt7ayhGXIvkJ78naxKSB7rkpnHLo",
  authDomain: "hongkai-d4751.firebaseapp.com",
  projectId: "hongkai-d4751",
  storageBucket: "hongkai-d4751.firebasestorage.app",
  messagingSenderId: "688692545548",
  appId: "1:688692545548:web:8f5c00369b2de8815cc629",
  measurementId: "G-0896G8GLDG"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase services
export const db = getFirestore(app)
export const storage = getStorage(app)
export const auth = getAuth(app)

export default app